import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { GraphUtils } from 'app/frontend/lib/analytics/graphs/utils.service';
import { BehaviorSubject } from 'rxjs';
import { ChartConstructorType } from "highcharts-angular";
@Component({
    selector: "mood-distribution-for-entire-period",
    templateUrl: "./mood-distribution-for-entire-period.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoodDistributionForEntirePeriodComponent implements OnChanges { 

    @Input() moodsForEntirePeriod: PieChartData;

    constructor(
        private translateService: TranslateService, 
        private graphUtils: GraphUtils
    ) {
    }
    
    chartOptions$ = new BehaviorSubject<Highcharts.Options>({});
    chartConstructor: ChartConstructorType = 'chart';

    ngOnChanges() { 
        if(this.moodsForEntirePeriod) {
            /**
             * Prepare data for the pie chart and filter out data series that don't contain data
             * @type {*[]}
             */
            const pieData = [
                {
                    name: this.translateService.instant('excellent'),
                    y: this.moodsForEntirePeriod.excellent,
                    color: this.graphUtils.colours('excellent')
                },
                {
                    name: this.translateService.instant('good'),
                    y: this.moodsForEntirePeriod.good,
                    color: this.graphUtils.colours('good')
                },
                {
                    name: this.translateService.instant('average'),
                    y: this.moodsForEntirePeriod.average,
                    color: this.graphUtils.colours('average')
                },
                {
                    name: this.translateService.instant('hard'),
                    y: this.moodsForEntirePeriod.hard,
                    color: this.graphUtils.colours('hard')
                },
                {
                    name: this.translateService.instant('bad'),
                    y: this.moodsForEntirePeriod.bad,
                    color: this.graphUtils.colours('bad')
                }
            ].filter((dataseries) => {
                return (dataseries.y !== null && dataseries.y > 0);
            });

            const moodDistributionChartConfig = this.moodDistributionChartConfig(pieData, this.graphUtils.moods_total(this.moodsForEntirePeriod));
            this.chartOptions$.next(moodDistributionChartConfig);
        }
    }

    moodDistributionChartConfig (pieData: Array<{name: string, y: number, color: string}>, moodsQuantity: number): Highcharts.Options {
        return {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                backgroundColor: this.graphUtils.graphBackgroundColor,
            },
            title: {
                text: 'Total<br>=<br>' + moodsQuantity + ' ' + this.translateService.instant('mood') + this.graphUtils.addS(moodsQuantity),
                align: 'center',
                verticalAlign: 'middle',
                y: -20
            },
            series: [{
                type: 'pie',
                innerSize: '50%',
                data: pieData,
                dataLabels: {
                    enabled: true,
                    useHTML: true,
                    format: '<p style="letter-spacing: .1px;font-size:13px; text-align: center;">{point.name}<br>{point.percentage:.1f} %</p>',
                    distance: -50,
                    y: -10,
                    style: {
                        fontWeight: '400',
                        color: 'rgba(255,255,255,.98)',
                        textOutline: 'none',
                        fontSize: '12px',
                    }
                },
                tooltip: {
                    headerFormat: '',
                    pointFormatter: (function(component) { // use to get access to graphUtils
                        return function() {
                                  const point = this; // this refers to the hovered point
                                  if(point && component){
                                    return point.name
                                    + ':<br><span style="font-weight:400;color:' + point.color +'">'+ point.y +'</span> '+ component.translateService.instant('mood')+ component.graphUtils.addS(point.y)
                                    +' (' +point.percentage.toFixed(0) +'%)'
                            }                              
                        }
                    })(this),
                },
            }],
            tooltip: {
                useHTML: true,
                backgroundColor: "rgba(255,255,255,1)"
            }
        };
    };
}


export interface PieChartData {
    excellent: number;
    good: number;
    average: number;
    hard: number;
    bad: number;
}